<div class="loadingComponent">
  <div class="loadingLine"></div>
</div>
